<template>
	<div
		v-if="loading"
		class="loading-spinner-container"
	>
		<LoadingSpinner :is-overlay="true" />
	</div>
	<div v-else>
		<div class="journeys-skew-banner journeys-skew-banner--small-padding">
			<div class="container">
				<div class="row">
					<div class="col journeys-skew-banner__content text-center">

					</div>
				</div>
			</div>
		</div>
		<div class="container pull-up">
			<div class="row flex-column flex-lg-row">
				<div class="col form-col-right">
					<div class="rounded-container rounded-container--small-padding">
						<h1 class="main-heading">{{ pageHeading }}</h1>

						<p>{{ pageSummary }}</p>

						<div class="callout--sand callout--small-padding mb-md-5 mb-4">
							<p>
								Have a question about your appointment? Here's what you
								<a
									href="javascript:void(0)"
									@click="() => {
										if (!faqEl) {
											return;
										}

										tryFocus(faqEl);
									}"
								>need to know</a>.
							</p>
						</div>
						<ValidationSummaryComponent v-if="someInvalid" />
						<div v-if="!existingCustomer">
							<TextInputField
								required
								:manual-input-dirtier="buttonClicked"
								:label-text="microcopy?.firstNameInputLabel"
								autocomplete="given-name"
								:error-text="microcopy?.firstNameInputError"
								@field-input="(payload) => {
									inputValue.firstName = payload.value;
									isValid.firstName = payload.isValid;
								}"
								@input-error="(payload) => {
									inputError = payload
								}"
							/>
							<TextInputField
								required
								:manual-input-dirtier="buttonClicked"
								:label-text="microcopy?.surnameInputLabel"
								autocomplete="family-name"
								:error-text="microcopy?.surnameInputError"
								@field-input="(payload) => {
									inputValue.surname = payload.value;
									isValid.surname = payload.isValid;
								}"
								@input-error="(payload) => {
									inputError = payload
								}"
							/>
							<TextInputField
								class="std-form-contained-item"
								required
								input-type="houseno"
								:manual-input-dirtier="buttonClicked"
								:label-text="microcopy?.houseNumberInputLabel"
								:error-text="microcopy?.houseNumberInputError"
								@field-input="(payload) => {
									inputValue.houseNumber = payload.value;
									isValid.houseNumber = payload.isValid;
								}"
								@input-error="(payload) => {
									inputError = payload
								}"
							/>
							<TextInputField
								class="std-form-contained-item"
								required
								input-type="postcode"
								:manual-input-dirtier="buttonClicked"
								:label-text="microcopy?.homePostcodeInputLabel"
								autocomplete="tel"
								:prefill-input="inputValue.postcode"
								:error-text="microcopy?.homePostcodeInputError"
								@field-input="(payload) => {
									inputValue.postcode = payload.value;
									isValid.postcode = payload.isValid;
								}"
								@input-error="(payload) => {
									inputError = payload
								}"
							/>
						</div>
						<DropdownField
							class="std-form-contained-item"
							v-if="selectedAdviser?.fullName !== '' && !professionComputed"
							:manual-input-dirtier="buttonClicked"
							:label-text="microcopy?.professionalFieldInputLabel"
							:options="professionalField"
							:error-text="microcopy?.professionalFieldInputError"
							@selected="(payload) => {
								inputValue.professionalField = payload;
							}"
						/>
						<TextInputField
							required
							input-type="email"
							:manual-input-dirtier="buttonClicked"
							:label-text="microcopy?.emailInputLabel"
							:error-text="microcopy?.emailInputError"
							:prefill-input="inputValue.email"
							@field-input="(payload) => {
								inputValue.email = payload.value;
								isValid.email = payload.isValid;
							}"
							@input-error="(payload) => {
								inputError = payload
							}"
						/>
						<TextInputField
							required
							input-type="phoneNumber"
							:manual-input-dirtier="buttonClicked"
							:label-text="microcopy?.contactNumberInputLabel"
							:error-text="microcopy?.contactNumberInputError"
							@field-input="(payload) => {
								inputValue.phoneNumber = payload.value;
								isValid.phoneNumber = payload.isValid;
							}"
							@input-error="(payload) => {
								inputError = payload
							}"
						/>
						<TextAreaComponent
							required
							:manual-input-dirtier="buttonClicked"
							:label-text="microcopy?.discussionTopicsInputLabel"
							:error-text="microcopy?.discussionTopicsInputError"
							@field-input="(payload) => {
								inputValue.discuss = payload.value;
								isValid.discuss = payload.isValid;
							}"
						/>
						<p><strong class="semi">{{ microcopy?.preferredContactTimeInputLabel }}</strong></p>
						<div class="input-wrapper input-wrapper__small-br radio-group">
							<RadioInputComponent
								v-for="time in timeOfDay"
								:key="time"
								as-checkbox
								:options="time"
								:selected-option="inputValue.selectedTime"
								@selected="(payload) => {
									inputValue.selectedTime[payload.text] = (payload.text);
									isValid.timeOfDay[payload.text] = payload.selected
								}"
							/>
						</div>
						<p>{{ microcopy?.preferredContactTimeSummary }}</p>

						<hr>

						<span v-html="microcopy?.marketingPreferencesLabel"></span>

						<div
							class="mb-4"
							v-html="microcopy?.marketingPreferencesSummary"
						/>
						<div class="std-checkbox-row std-form-item std-form-item--sm">
							<CheckBox
								label-text="Email"
								@selected="(payload) => {
									inputValue.contactMethod.email = payload;
								}"
							/>
							<CheckBox
								label-text="Text message"
								@selected="(payload) => {
									inputValue.contactMethod.textMessage = payload;
								}"
							/>
							<CheckBox
								label-text="Phone"
								@selected="(payload) => {
									inputValue.contactMethod.phone = payload;
								}"
							/>
							<CheckBox
								label-text="Post"
								@selected="(payload) => {
									inputValue.contactMethod.post = payload;
								}"
							/>
						</div>
						<div v-html="microcopy?.disclaimer" />

						<div style="margin-top: 32px;">
							<GenericButton
								:label-text="microcopy?.submitButtonLabel"
								@button-click="handleClick"
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import BackButton from '@/shared/components/BackButton.vue';
import TextInputField from '@/shared/components/TextInputField.vue';
import RadioInputComponent from '@/shared/components/RadioInputComponent.vue';
import CheckBox from '@/shared/components/CheckBox.vue';
import GenericButton from '@/shared/components/GenericButton.vue';
import DropdownField from '@/shared/components/DropdownField.vue';
import TextAreaComponent from '@/shared/components/TextAreaComponent.vue';
import ValidationSummaryComponent from '../../shared/components/ValidationSummaryComponent.vue';
import LoadingSpinner from '@/shared/components/LoadingSpinner.vue';

import { createTimeoutSignal, scrollToInvalidField } from '@/shared/helpers';

import router from '../router/index.js';

import { mapStores, mapState, mapActions } from 'pinia';
import { useAppointmentReferralStore } from '../stores/appointmentReferralStore.js';

import { tryFocus } from '../../../lib/utils/try-focus';

export default {
	components: {
		ValidationSummaryComponent,
		BackButton,
		TextInputField,
		RadioInputComponent,
		CheckBox,
		GenericButton,
		TextAreaComponent,
		DropdownField,
		LoadingSpinner
	},
	data() {
		return {
			inputError: false,
			inputValue: {
				firstName: '',
				surname: '',
				houseNumber: '',
				postcode: '',
				email: '',
				phoneNumber: '',
				discuss: '',
				selectedTime: {},
				contactMethod: {
					email: false,
					phone: false,
					post: false,
					textMessage: false,
				},
				professionalField: '',
			},
			timeOfDay: {
				morning: {
					text: 'Morning',
				},
				afternoon: {
					text: 'Afternoon',
				},
				evening: {
					text: 'Evening',
				},

			},
			progressionText: 'Submit your request',
			existingCustomerFields: {
				email: '',
				phoneNumber: false,
				discuss: false,
				timeOfDay: {
					Morning: false,
					Afternoon: false,
					Evening: false,
				},
			},
			newCustomerFields: {
				firstName: false,
				surname: false,
				houseNumber: false,
				postcode: false,
			},
			isValid: {
				timeOfDay: {
					Morning: false,
					Afternoon: false,
					Evening: false,
				},
			},
			microcopy: '',
			buttonClicked: false,
			professionalField: ['Teacher', 'Hospital', 'GP', 'Dentist', 'Other'],
			campaignCode: '',
			loading: false,
		};
	},
	computed: {
		...mapStores(useAppointmentReferralStore),
		...mapState(useAppointmentReferralStore, ['existingCustomer', 'professionAndPostcode', 'existingCustomerDetails', 'financialAdviserLocation', 'financialAdviserName', 'profession', 'financialAdviser', 'returnedDetails', 'getAllDataForExistingCustomerSubmission', 'getAllDataForNewCustomerSubmission', 'selectedAdviser']),
		allInputsValid() {
			const atLeastOneTimeOfDaySelected = Object?.values(this.isValid.timeOfDay).some(value => value);
			const otherFieldsValid = Object.values(this.isValid)
				.filter(value => typeof value === 'boolean')
				.every(value => value);

			return atLeastOneTimeOfDaySelected && otherFieldsValid;
		},
		financialAdviserImage() {
			if (this.financialAdviser?.image) {
				return 'data:image/png;base64,' + this.financialAdviser.image;
			}
		},
		professionComputed() {
			return this.profession?.type ?? this.profession;
		},
		professionValue() {
			switch (this.inputValue?.professionalField) {
				case 'Hospital':
					return 'HospitalDoctor';
				case 'Other':
					return 'Wesleyan';
				default:
					return this.inputValue?.professionalField;
			}
		},
		professionIcon() {
			if (['Hospital Doctor', 'Hospital'].includes(this.professionComputed)) {
				return '/assets/images/hospital-profession.svg';
			}
			else if (['GP', 'Practice'].includes(this.professionComputed)) {
				return '/assets/images/gp-profession.svg';
			}
			else if (['Dentist', 'Dental'].includes(this.professionComputed)) {
				return '/assets/images/dental-profession.svg';
			}
			else if (['Teacher', 'Education'].includes(this.professionComputed)) {
				return '/assets/images/education-profession.svg';
			}
			else {
				return '/assets/images/other-profession.svg';
			}
		},
		financialAdviserLocationComputed() {
			if (this.existingCustomer) {
				return this.financialAdviserLocation?.toUpperCase() ?? this.existingCustomerDetails?.postcode?.slice(0, 3).toUpperCase();
			}
			else {
				return this.financialAdviserLocation ? this.financialAdviserLocation.toUpperCase() : '';
			}
		},
		data() {
			return this.existingCustomer ? this.getAllDataForExistingCustomerSubmission : this.getAllDataForNewCustomerSubmission;
		},
		someInvalid() {
			return !this.allInputsValid && this.buttonClicked;
		},
		financialAdviserBiography() {
			return this.financialAdviser?.biography ?? this.microcopy?.financialAdviserBiography;
		},
		pageHeading() {
			return this.microcopy?.heading?.replace('{|FinancialAdviserName|}', this?.selectedAdviser?.fullName ?? this?.financialAdviserName)
		},
		pageSummary() {
			return this.existingCustomer ? this.microcopy?.existingCustomersSummary?.replace('{|FinancialAdviserName|}', this?.selectedAdviser?.fullName ?? this?.financialAdviserName) : this.microcopy?.newCustomersSummary;
		},
		faqEl() {
			return document.querySelector('.step--yourfinancialadviser');
		}
	},
	mounted() {
		this.initialiseIsValid();
		this.initialiseCampaignCodes();

		this.microcopy = window.bookAnAppointmentReferralMicrocopy?.yourFinancialAdviser;
		this.microcopyBuyapowa = window.bookAnAppointmentReferralMicrocopy?.buyapowa;
		document.title = this.microcopy?.metaTitle
		if (this.existingCustomer) {
			this.inputValue.email = this.existingCustomerDetails.email;
			this.isValid.email = !!this.existingCustomerDetails.email;
		} else {
			if (!['Dental', 'Education'].includes(this.professionAndPostcode.profession.text)) {
				if (!this.selectedAdviser) {
					this.inputValue.postcode = this.professionAndPostcode.postcode;
					this.isValid.postcode = true;
				}
			}
		}
		const el = document.querySelector('.step--yourfinancialadviser');
		if (el !== null && el.classList.contains('d-none')) {
			el.classList.remove('d-none');
		}
	},
	unmounted() {
		const el = document.querySelector('.step--yourfinancialadviser');
		if (el?.classList.contains('d-none')) {
			el.classList.add('d-none');
		}
	},
	methods: {
		...mapActions(useAppointmentReferralStore, ['postFinalSubmissionData']),
		handleBackButton() {
			router.back();
		},
		handleSearchForNewAdviser() {
			// Set cookie as expired so it doesnt automatically route back to adviser page
			document.cookie = `WesleyanFinancialConsultant=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${document.location.hostname};`;
			router.push('customer-type');
		},
		handleClick() {
			if (!this.allInputsValid) {
				this.buttonClicked = true;
				setTimeout(() => {
					scrollToInvalidField()
				}, "50");
			}
			else {
				let submissionData = this.inputValue;
				if (['Dental', 'Education'].includes(this.professionAndPostcode.profession.text)) {
					submissionData.workPostcode = this.professionAndPostcode?.postcode;
				}
				submissionData.contactMethod.timestamp = new Date().toISOString();
				submissionData.selectedTime = Object.entries(this.isValid.timeOfDay)
					.filter(([time, isSelected]) => isSelected)
					.map(([time, isSelected]) => time);
				this.postFinalSubmissionData(submissionData);
				this.submitForm();
			}
		},
		submitForm() {
			this.loading = true;

			const myHeaders = new Headers();
			myHeaders.append("Content-Type", "application/json");
			let raw;
			if (this.data?.campaignCode === undefined) {
				raw = {};
			}
			else {
				raw = this.data;
			}
			if (!this.existingCustomer) {
				raw.segment = this.professionValue;
			}
			raw.customerEmailSettings = window.bookAnAppointmentReferralMicrocopy?.emailSetting
			raw.campaignCode = this.campaignCode;
			raw = JSON.stringify(raw);

			appInsights.trackTrace({
				message: '[BAARefJourney] API submission - Started',
				properties: { area: 'appointment-referral-journey', hostname: location.hostname },
				severityLevel: 1
			});

			const options = {
				method: 'POST',
				headers: myHeaders,
				body: raw,
				redirect: 'follow',
				signal: createTimeoutSignal()
			};

			fetch('/sapi/FinancialConsultants/submit-referral', options)
				.then(async (res) => {
					if (!res.ok) {
						console.error(`Request failed with status ${res.status}`);
						appInsights.trackTrace({
							message: `[BAARefJourney] API submission - Failed - received HTTP ${res.status}`,
							properties: { area: 'appointment-referral-journey', hostname: location.hostname },
							severityLevel: 4
						});

						document.cookie = 'WesleyanFinancialConsultant=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
						return router.push('adviser-error');
					}

					appInsights.trackTrace({
						message: '[BAARefJourney] API submission - Succeeded',
						properties: { area: 'appointment-referral-journey', hostname: location.hostname },
						severityLevel: 1
					});

					this.buyapowaScriptTrigger();

					return router.push('success');
				})
				.catch((e) => {
					if (
						e instanceof DOMException
						&& e.name === 'AbortError'
					) {
						console.error('Request timed out');
						appInsights.trackTrace({
							message: '[BAARefJourney] API submission - Failed - Timed out',
							properties: { area: 'appointment-referral-journey', hostname: location.hostname },
							severityLevel: 3
						});
					} else {
						console.log(e);
						appInsights.trackException({
							exception: e,
							properties: { area: 'appointment-referral-journey' },
							severityLevel: 4
						});
					}

					document.cookie = 'WesleyanFinancialConsultant=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
					return router.push('adviser-error');
				})
				.finally(() => {
					this.loading = false;
				});
		},
		initialiseIsValid() {
			if (this.existingCustomer) {
				this.isValid = this.existingCustomerFields;
			}
			else {
				this.isValid = { ...this.newCustomerFields, ...this.existingCustomerFields };
			}
			this.inputValue.professionalField = this.professionComputed
			this.isValid.professionalField = true;
		},
		buyapowaScriptTrigger() {
			if (!this.existingCustomer) {
				var buyapowa = new Buyapowa({ url: this.microcopyBuyapowa?.marketDomain, market: this.microcopyBuyapowa?.market });
				buyapowa.track({
					"customer_name": `${this.inputValue.firstName} ${this.inputValue.surname}`,
					"customer_email": `${this.inputValue.email}`,
					"order_number": `${this.inputValue.phoneNumber}`
				});
			}
		},
		initialiseCampaignCodes() {
			const existingCustomerCampaignCode = window.bookAnAppointmentReferralMicrocopy.campaignCode?.existingCustomer;
			const newCustomerCampaignCode = window.bookAnAppointmentReferralMicrocopy.campaignCode?.newCustomer;
			this.campaignCode = this.existingCustomer ? existingCustomerCampaignCode : newCustomerCampaignCode;
		},
		tryFocus
	},
};
</script>
